import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import { useHistory } from "react-router-dom";
import { setLoading, setSnackInfo } from '../redux/actions/appAction';
import { Paper, Grid, Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { ROLENAME } from '../utils/index';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: 'black',
    },
}));

const SalesUserLeadMetricsTable = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const { userDetails } = useSelector(state => state.user);
    const [marketingUserCount, setMarketingUserCount] = useState({});

    useEffect(() => {
        checkUser(props.role)
        if ((props.role === ROLENAME.SalesManager || props.role === ROLENAME.SalesHead || props.role === ROLENAME.DGM_Sales || props.role === ROLENAME.AssistantSalesManager || props.role === ROLENAME.AGMSales)) {
            separateLeadStatusWise(props.salesdata);
        }
    }, [props])

    const checkUser = (roleid) => {
        if (roleid === ROLENAME.MarketingManager || roleid === ROLENAME.MarketingUser) {
            getLeadCountDetails(props.marketingdata);
        } else if ((roleid === ROLENAME.SalesManager || roleid === ROLENAME.SalesHead || props.role === ROLENAME.DGM_Sales || props.role === ROLENAME.AssistantSalesManager || props.role === ROLENAME.AGMSales)) {
            if (props.isUserSelected && props.isUserSelected.length === 0) {
                getSalesLeadCountDetails(props.salesdata);
            }
        } else if (roleid === ROLENAME.SalesUser) {
            getSalesLeadCountDetails(props.salesdata);
        } else {
            separateLeadStatusWise(props.selectedUserDetails);
        }
    }

    // Get Marketing user Lead details
    const getLeadCountDetails = async (data) => {
        Object.keys(data).forEach(function (key) {
            if (key === props.selectedexpcenter) {
                var value = data[key];
                separateLeadStatusWise(value);
            }
        });
    }

    // Get Sales user and manager Lead details
    const getSalesLeadCountDetails = async (data) => {
        separateLeadStatusWise(data);
    }

    const separateLeadStatusWise = (data) => {
        if (props.role === ROLENAME.MarketingManager) {
            setMarketingUserCount({ target: data.target, targetAchieved: data.achived })
        } else if (props.role === ROLENAME.MarketingUser || props.role === ROLENAME.SalesUser) {
            setMarketingUserCount(data)
        } else if (props.role === ROLENAME.SalesManager || props.role === ROLENAME.SalesHead || props.role === ROLENAME.DGM_Sales || props.role === ROLENAME.AssistantSalesManager || props.role === ROLENAME.AGMSales) {
            data.forEach(ele => {
                if (ele.name === 'topInfo') {
                    setMarketingUserCount(ele)
                }
            })
        }
    }

    const changePageRouteNew = (toGoStage) => {
        if (toGoStage === 'leadToMeeting') {
            history.push(`/Lead-To-Meeting`, {
                data: marketingUserCount,
                displayData: props.salesdata
            });
        }
        else if (toGoStage === 'leadToOrder') {
            history.push(`/Lead-To-Order`, {
                data: marketingUserCount,
                displayData: props.salesdata
            });
        }
        else if (toGoStage === 'meetingToOrder') {
            history.push(`/Meeting-To-Order`, {
                data: marketingUserCount,
                displayData: props.salesdata
            });
        }
        else if (toGoStage === 'leadInMarketing') {
            history.push(`/Lead-In-Marketing`, {
                data: marketingUserCount,
                displayData: props.salesdata
            });
        } else if (toGoStage === 'leadsAssigned') {
            history.push(`/Lead-Assigned`, {
                data: marketingUserCount,
                displayData: props.salesdata
            });
        }
    }

    return (
        <>
            <div style={{ display: 'flex', marginTop: 10, marginBottom: 10 }}>
                <div className={classes.root}>
                    <Grid container spacing={3}>
                        {
                            props.role === ROLENAME.SalesUser && (
                                <Grid item xs={12}>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Metrics</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: 'bold' }}>Counts/Values</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {marketingUserCount?.leadToMeeting && (
                                                    <>
                                                        <TableRow>
                                                            <TableCell align="center" component="th">Leads Assigned</TableCell>
                                                            <TableCell align="center" component="th">
                                                                <Button style={{ padding: 0 }} color="primary" onClick={() => changePageRouteNew('leadsAssigned')}>
                                                                    {marketingUserCount.leadToMeeting.leadToMeetingTotal}
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="center" component="th">Lead In Marketing</TableCell>
                                                            <TableCell align="center" component="th">
                                                                <Button style={{ padding: 0 }} color="primary" onClick={() => changePageRouteNew('leadInMarketing')}>
                                                                    {marketingUserCount.leadToMeeting.leadInMarketing}
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="center" component="th">Lead To Meeting</TableCell>
                                                            <TableCell align="center" component="th">
                                                                <Button style={{ padding: 0 }} color="primary" onClick={() => changePageRouteNew('leadToMeeting')}>
                                                                    {(marketingUserCount.leadToMeeting.leadToMeetingTotal !== 0)
                                                                        ? ((marketingUserCount.leadToMeeting.leadToMeetingVal / marketingUserCount.leadToMeeting.leadsInSales) * 100).toFixed(0) + "% / " + marketingUserCount.leadToMeeting.leadToMeetingVal + "/" + marketingUserCount.leadToMeeting.leadsInSales
                                                                        : `0% / 0/0`}
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="center" component="th">Meeting to Order</TableCell>
                                                            <TableCell align="center" component="th">
                                                                <Button style={{ padding: 0 }} color="primary" onClick={() => changePageRouteNew('meetingToOrder')}>
                                                                    {marketingUserCount.leadToMeeting.leadToMeetingVal !== 0
                                                                        ? ((marketingUserCount.leadToMeeting.MeetingToOrder / marketingUserCount.leadToMeeting.leadToMeetingVal) * 100).toFixed(0) + "% / " + marketingUserCount.leadToMeeting.MeetingToOrder + "/" + marketingUserCount.leadToMeeting.leadToMeetingVal
                                                                        : `0% / 0/0`}
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell align="center" component="th">Lead to Order</TableCell>
                                                            <TableCell align="center" component="th"> 
                                                                <Button style={{ padding: 0 }} color="primary" onClick={() => changePageRouteNew('leadToOrder')}>
                                                                    {marketingUserCount.leadToMeeting.leadToMeetingTotal !== 0
                                                                        ? ((marketingUserCount.leadToMeeting.MeetingToOrder / marketingUserCount.leadToMeeting.leadsInSales) * 100).toFixed(0) + "% / " + marketingUserCount.leadToMeeting.MeetingToOrder + "/" + marketingUserCount.leadToMeeting.leadsInSales
                                                                        : `0% / 0/0`}
                                                                </Button>
                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            )
                        }
                    </Grid>
                </div>
            </div>
        </>
    )
}

export default connect(null, { setLoading, setSnackInfo })(SalesUserLeadMetricsTable)

